import { Observer } from "mobx-react";
import { css as style } from "@emotion/css";
import React from "react";
import ReactMarkdown from "react-markdown";
import gfm from "remark-gfm";
import styles from "./customized-react-markdown.css";
import classnames from "classnames";
import remarkBreaks from "remark-breaks";

interface CustomizedReactMarkdownProps {
  /** Source of markdown text */
  source: string;
  /** If true - img tag will be hidden (display:none) */
  hideImages?: boolean;
  /** If true - content will be in one line with text overflow ellipsis */
  noWrap?: boolean;
}

/** A customized version of react markdown */
export const CustomizedReactMarkdown = (
  props: CustomizedReactMarkdownProps
) => {
  const { hideImages, source, noWrap } = props;

  const hideImageStyle = style({ img: { display: "none" } });

  const noWrapStyle = style({
    display: "-webkit-box",
    WebkitLineClamp: 1,
    WebkitBoxOrient: "vertical",
    overflow: "hidden",
  });

  return (
    <Observer>
      {() => (
        <ReactMarkdown
          className={classnames(
            styles.container,
            hideImages && hideImageStyle,
            noWrap && noWrapStyle
          )}
          children={source}
          remarkPlugins={[[gfm], [remarkBreaks]]}
          components={
            {
              // Customise individual html components here
              // see https://github.com/remarkjs/react-markdown#appendix-b-components
            }
          }
          linkTarget={"_blank"}
        />
      )}
    </Observer>
  );
};
